var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bp-icon",style:(_vm.componentStyle)},[_vm._t("default",[_c('i',{class:_vm.icon,style:(_vm.iconStyle)})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }